export const trucktypes = {
    0: 'Dump Truck',
    1: 'Box Truck',
}